import Vue from "vue";
import Vuelidate from 'vuelidate';
import moment from 'moment';
import App from "./App.vue";
import router from "./router";
import store from "./store";
import icons from "./icons";
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import BootstrapVue from "bootstrap-vue";
import {
  FontAwesomeIcon
} from "@fortawesome/vue-fontawesome";
import { ApplicationInsights } from '@microsoft/applicationinsights-web'

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)
Vue.use(BootstrapVue);
Vue.use(Vuelidate);
const shared = {}
shared.install = function (Vue, options) {
  Vue.convertCurrency = function (value, country) {
    if (typeof value == "string" && !(value.toString().indexOf('.') != -1)) {
      value = parseInt(value);
    } else if (typeof value == "string" && value.toString().indexOf('.') != -1) {
      value = value
    } else if (typeof value !== "number") {
      return value;
    }
    let countryCode = [
      { Code: "en-GB", Country: "UK- LE006" },
      { Code: "en-US", Country: "USA- LE001" },
      { Code: "en-CA", Country: "Canada- LE004" },
      { Code: "en-IN", Country: "India- LE003" }
    ];
    let code = _.filter(countryCode, (mr) => mr.Country.toUpperCase() === country.toUpperCase());
    if (typeof value == "string" && value.toString().indexOf('.') != -1) {
      var formatter = new Intl.NumberFormat(code[0].Code, { minimumFractionDigits: 2 });
    } else {
      var formatter = new Intl.NumberFormat(code[0].Code);
    }
    return formatter.format(value);
  },
    Vue.countryCurrency = function (country) {
      let currency = [
        { Code: "USD", Symbol: "$", Country: "USA- LE001" },
        { Code: "CAD", Symbol: "C$", Country: "Canada- LE004" },
        { Code: "INR", Symbol: "Rs", Country: "India- LE003" }
      ];
      let code = _.filter(currency, (mr) => mr.Country.toUpperCase() === country.toUpperCase());
      return code;
    },
    Vue.filter("formatDateTime", value => {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    });
}
Vue.use(shared)
icons.load();

Vue.config.productionTip = false;

const appInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.VUE_APP_AppInsights_Connection,
    disableFetchTracking: false,
    enableCorsCorrelation: true
  }
});
appInsights.loadAppInsights();
appInsights.trackPageView();
var telemetryInitializer = (envelope) => {
  envelope.data.userName = sessionStorage.getItem('username');
};
appInsights.addTelemetryInitializer(telemetryInitializer);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");